export enum LeadStatus {
  NEW = 'new',
  CONTACTED = 'contacted',
  QUALIFIED = 'qualified',
  PROPOSAL = 'proposal',
  NEGOTIATION = 'negotiation',
  CLOSED_WON = 'closed_won',
  CLOSED_LOST = 'closed_lost',
  UNQUALIFIED = 'unqualified',
}

export enum LeadSource {
  MANUAL = 'manual',
  CSV_IMPORT = 'csv_import',
  WEB_SCRAPING = 'web_scraping',
  API_INTEGRATION = 'api_integration',
  REFERRAL = 'referral',
  WEBSITE_FORM = 'website_form',
}

export interface CreateLead {
  email: string;
  name?: string | undefined;
  company?: string | undefined;
  jobTitle?: string | undefined;
  phone?: string | undefined;
  website?: string | undefined;
  linkedinUrl?: string | undefined;
  industry?: string | undefined;
  companySize?: string | undefined;
  budgetEstimate?: number | undefined;
  location?: string | undefined;
  source?: LeadSource | undefined;
  notes?: string | undefined;
  tags?: string[] | undefined;
}

export interface UpdateLead {
  name?: string;
  company?: string;
  jobTitle?: string;
  phone?: string;
  website?: string;
  linkedinUrl?: string;
  industry?: string;
  companySize?: string;
  budgetEstimate?: number;
  location?: string;
  status?: LeadStatus;
  notes?: string;
  tags?: string[];
}

export interface Lead {
  id: number;
  email: string;
  name?: string;
  company?: string;
  jobTitle?: string;
  phone?: string;
  website?: string;
  linkedinUrl?: string;
  industry?: string;
  companySize?: string;
  budgetEstimate?: number;
  location?: string;
  status: LeadStatus;
  source: LeadSource;
  notes?: string;
  tags?: string[];
  teamId: number;
  createdAt: Date;
  updatedAt: Date;
  lastContactedAt?: Date;
  enrichmentData?: any;
}

export interface LeadFilter {
  status?: LeadStatus;
  source?: LeadSource;
  industry?: string;
  companySize?: string;
  minBudget?: number;
  maxBudget?: number;
  search?: string;
  tags?: string[];
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface ImportResult {
  totalRows: number;
  successCount: number;
  failedCount: number;
  updatedCount: number;
  duplicateCount: number;
  errors: Array<{
    row: number;
    email?: string;
    errors: string[];
  }>;
  message: string;
}

export interface LeadStats {
  totalLeads: number;
  byStatus: Record<LeadStatus, number>;
  bySource: Record<LeadSource, number>;
  recentLeads: number;
  avgBudget: number;
  topIndustries: Array<{ industry: string; count: number }>;
}

export interface LeadsPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface LeadsResponse {
  data: Lead[];
  pagination: LeadsPagination;
}

export interface ImportOptions {
  skipHeader?: boolean;
  delimiter?: string;
  overrideExisting?: boolean;
  defaultSource?: LeadSource;
}